import React from "react";
import {
	Box,
	Image,
	Text,
	Flex,
	Button,
	useMediaQuery,
	Img,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";
import "./swiper-styles.css";
import "swiper/swiper.css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import PageLoaderURL from "../img/loader.gif";
import { PageLoading } from "../packages";
import Dashnode_logo_with_name from "../img/Dashnode_logo_with_name.png";
import { useLocation, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Scrollbar, A11y, Autoplay } from "swiper/modules";
import cadToCostImg from "../img/cad to cost.svg";
import detailedCostingImg from "../img/detailed costing.svg";
import dfmImg from "../img/dfm.svg";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

export const PublicLayout: React.FC<any> = ({ Component, ...rest }) => {
	const [isMobile] = useMediaQuery("(max-width: 768px)");
	const [pageLoadingData] = useSelector((state: any) => [state.pageLoading]);
	const location = useLocation();
	const navigate = useNavigate();
	const page = location.pathname.split("/")[1];

	// For tabs toggle
	const isLoginForm = page === "login" || page === ""; // default to login if empty?
	const isRegisterForm = page === "register";
	const showTabs = isLoginForm || isRegisterForm;

	const slides = [
		{
			img: cadToCostImg,
			textTitle: "CAD to cost in seconds",
			textDescription: (
				<>
					Upload a CAD file and get an instant
					<br />
					machining cost estimate.
				</>
			),
		},
		{
			img: detailedCostingImg,
			textTitle: "Detailed reports with cost breakdowns",
			textDescription: (
				<>
					See costs by operation, material, and
					<br />
					machining steps and adjust estimates easily.
				</>
			),
		},
		{
			img: dfmImg,
			textTitle: "Built-in DFM insights",
			textDescription: (
				<>
					Detect manufacturability issues before
					<br /> production starts.
				</>
			),
		},
	];

	const handleTabClick = (path: string) => {
		// preserve search params
		navigate(`/${path}${location.search}`, { replace: true });
	};

	return (
		<Box w="100%" minH="100vh" bg="#fff" overflowX="hidden">
			<Flex
				minH="100vh"
				flexDir={isMobile ? "column" : "row"}
				alignItems="center"
				justifyContent="space-between"
			>
				{/* Left Side Container (Slider) */}
				<Flex
					display={{ base: "none", md: "flex" }}
					w={{ base: "0", md: "45%" }}
					bgGradient="linear(to-b, #1c70ed, #196ae3, #024dbd)"
					position="relative"
					alignItems=""
					justifyContent="center"
					p="1rem"
					ml="2rem"
					h="95vh"
					borderRadius="1rem"
				>
					<Flex
						flexDir="column"
						alignItems="center"
						justifyContent="center"
						w="100%"
						h="100%"
					>
						<Text
							color="#fff"
							fontSize="1.75rem"
							fontWeight={600}
							textAlign="center"
						>
							Welcome to Dashnode
						</Text>
						<Flex
							className="auth-swiper"
							alignItems="center"
							justifyContent="center"
							mt="2rem"
							w="100%"
							overflow="hidden"
						>
							<Swiper
								modules={[Pagination, Scrollbar, A11y, Autoplay]}
								spaceBetween={2}
								slidesPerView={1}
								initialSlide={0}
								autoplay={{
									delay: 3000,
								}}
								loop={true}
								pagination={{
									clickable: true,
								}}
								style={{ height: "100%" }}
							>
								{slides?.map((each: any, index: number) => (
									<SwiperSlide key={index}>
										<Flex
											direction="column"
											alignItems="center"
											justifyContent="center"
											h="100%"
											textAlign="center"
											color="#fff"
										>
											<Img
												src={each.img}
												objectFit="contain"
												style={{ height: "50vh" }}
											/>
											<Box>
												<Text
													fontSize="1.875rem"
													fontWeight={600}
													wordBreak="break-word"
												>
													{each.textTitle}
												</Text>
												<Text fontSize="1.125rem">{each.textDescription}</Text>
											</Box>
										</Flex>
									</SwiperSlide>
								))}
							</Swiper>
						</Flex>
					</Flex>
				</Flex>

				{/* Right Side Container */}
				<Flex
					w={{ base: "100%", md: "50%" }}
					h="100vh"
					bg="#fff"
					flexDir="column"
					alignItems="center"
					justifyContent="flex-start"
					pt={{ base: "10vh", md: "15vh", lg: "18vh" }}
					px={{ base: "1rem", md: "3rem" }}
					pb="3rem"
					position="relative"
					zIndex={10}
					overflowY="auto"
				>
					<Flex w="100%" maxW="450px" flexDir="column">
						{/* Logo */}
						<Flex
							justifyContent={{ base: "center", md: "flex-start" }}
							mb="3rem"
						>
							<Image
								src={Dashnode_logo_with_name}
								alt="dashnode"
								h="2rem"
								objectFit="contain"
							/>
						</Flex>

						{/* Tabs for Sign Up / Sign In */}
						{showTabs && (
							<Flex
								bg="#F4F6F8"
								borderRadius=".5rem"
								p="0.375rem"
								mb="1.5rem"
								w="100%"
							>
								<Button
									flex="1"
									borderRadius=".5rem"
									bg={isRegisterForm ? "#0C64E8" : "transparent"}
									color={isRegisterForm ? "#fff" : "#9C9AA5"}
									_hover={{
										bg: isRegisterForm ? "#0C64E8" : "#E2E8F0",
										color: isRegisterForm ? "#fff" : "#1A202C",
									}}
									onClick={() => handleTabClick("register")}
									h="2.75rem"
								>
									Sign Up
								</Button>
								<Button
									flex="1"
									borderRadius=".5rem"
									bg={isLoginForm ? "#0C64E8" : "transparent"}
									color={isLoginForm ? "#fff" : "#9C9AA5"}
									_hover={{
										bg: isLoginForm ? "#0C64E8" : "#E2E8F0",
										color: isLoginForm ? "#fff" : "#1A202C",
									}}
									onClick={() => handleTabClick("login")}
									h="2.75rem"
								>
									Sign In
								</Button>
							</Flex>
						)}

						{/* Form Component Container */}
						<Box w="100%">
							<Component {...rest} />
						</Box>
					</Flex>
				</Flex>

				{pageLoadingData?.loading && (
					<PageLoading
						pageLoading={pageLoadingData}
						pageLoaderURL={PageLoaderURL}
					/>
				)}
			</Flex>
		</Box>
	);
};
